import { render, staticRenderFns } from "./Mobile.vue?vue&type=template&id=68922fb6&scoped=true&"
var script = {}
import style0 from "./Mobile.vue?vue&type=style&index=0&id=68922fb6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68922fb6",
  null
  
)

component.options.__file = "Mobile.vue"
export default component.exports